'use strict';

function connexionFunction(g) {
  function init() {
    $btnClientConnected = $('.js-btn--client-connected');
    $btnClientConnectedMobile = $('.js-client-mobile-btn');
    $panelConnexion = $('.panel-connexion');
    $isOpen = false;

    // Quand on clique dans le body...
    g.$body.on('click', function(e) {
      if ($isOpen) {
        // ... si le clic se fait en dehors du panel
        // ou sur le bouton Votre espace client à l'intérieur du panel
        if (
          $(e.target).closest($panelConnexion).length == 0 ||
          $(e.target).closest($('.panel-connexion__title')).length > 0
        ) {
          closePanel();
        }
      } else {
        // ... si le clic se fait sur le bouton "Votre espace client", on ouvre le panel
        if (
          $(e.target).closest($btnClientConnected).length > 0 ||
          $(e.target).closest($btnClientConnectedMobile).length > 0
        ) {
          openPanel();
        }
      }
    });

    $(window).on('resize', setPositionPanel);

    // Ferme le panel au scroll
    $(window).on('scroll', closePanel);

    deconnexion();
  }

  function openPanel() {
    setPositionPanel();
    g.$body.addClass('body---panel-connexion-opened');
    $isOpen = true;
  }

  function closePanel() {
    g.$body.removeClass('body---panel-connexion-opened');
    $isOpen = false;
  }

  function setPositionPanel() {
    // [Position TOP]
    // 1. on récupère la position top du btn
    // 2. on décale le panel de quelques pixels vers le haut pour caler l'affichage
    $positionPanelTop = $btnClientConnected.offset().top;
    $positionPanelTop = $positionPanelTop - 11;

    // [Position LEFT]
    // 1. on récupère la position left du btn
    // 2. on enlève la moitié de la largeur du panel
    // 3. on enlève l'épaisseur des bordures
    // 4. on décale de quelques pixels vers la droite pour caler l'affichage
    $positionPanelLeft = $btnClientConnected.offset().left;
    $positionPanelLeft = $positionPanelLeft - $panelConnexion.outerWidth() / 2;
    $positionPanelLeft = $positionPanelLeft - 2;
    $positionPanelLeft = $positionPanelLeft + 10;

    // [Position LEFT] : décalage de 26px pour équilibrer avec le padding du sticky header
    if (!g.$body.hasClass('is-menu-collapse')) {
      $positionPanelLeft = $positionPanelLeft + 26;
    }

    // [Position LEFT] : changement de la position dûe au changement de taille de texte
    if (window.innerWidth < 1336) {
      $positionPanelLeft = $positionPanelLeft - 17;
    }

    if (window.innerWidth >= 1024) {
      // En version desktop, on positionnne le panel en fonction de la position du bouton "Votre espace client"
      $panelConnexion.offset({top: $positionPanelTop, left: $positionPanelLeft});
    } else {
      // En version mobile, on positionnne le panel en fonction de la position du bouton "Votre espace client" mobile
      $panelConnexion.offset({
        top: $btnClientConnectedMobile.offset().top + 10,
        left:
          $btnClientConnectedMobile.offset().left -
          $panelConnexion.outerWidth() +
          $btnClientConnectedMobile.outerWidth() -
          10
      });
    }
  }

  function deconnexion() {
    $('.js-btn-deconnexion').on('click', function(event) {
      event.preventDefault();
      $.support.cors = true;
      $.ajax({
        url: $(this).data('target') + 'api/identity/logout',
        type: 'POST',
        xhrFields: {
          withCredentials: true
        },
        success: function() {
          location.reload();
        },
        error: function() {
          location.reload();
        }
      });
    });
  }

  init();
}
